import {ConfigProvider, type ThemeConfig} from 'antd'
import type {FC, PropsWithChildren} from 'react'
import locale from './locale'
export interface Props {
  themeType?: 'yellow' | 'blue'
  [key: string]: any
}

const themeConfig: Record<string, ThemeConfig> = {
  blue: {
    token: {
      colorPrimary: '#33A0FF',
      colorBgLayout: '#33a0ff',
    },
    components: {
      Input: {
        colorBgContainer: '#F2F4F7', // 背景色
        colorTextPlaceholder: '#9096A3', // Placeholder字体颜色
        colorText: '#1F2737', // 输入字体颜色
        borderRadius: 8,
      },
      Select: {
        colorBgContainer: '#F2F4F7', // 背景色
        colorTextPlaceholder: '#9096A3', // Placeholder字体颜色
        colorText: '#1F2737', // 输入字体颜色
        activeBorderColor: '#33A0FF', // 激活态边框色
        optionSelectedBg: '#EBF6FF',
        borderRadius: 8,
      },
      Button: {
        borderRadius: 8,
        defaultShadow: '#fff',
        /*defaultBg: '#F2F4F7',
        defaultColor: '#1F2737',
        defaultBorderColor: '#F2F4F7',
        defaultHoverBorderColor: '#E5E7EB',
        defaultHoverBg: '#E5E7EB',
        defaultHoverColor: '#1F2737',
        defaultActiveBorderColor: '#D7DAE0',
        defaultActiveBg: '#D7DAE0',
        defaultActiveColor: '#1F2737',*/
      },
      Table: {
        headerBg: '#F9FAFB', // 背景色
        headerColor: '#4B5363', // 表头文字颜色
        headerSplitColor: '#F9FAFB', // 表头分割线颜色
        headerBorderRadius: 8,
        borderRadius: 8,
      },
      Pagination: {
        itemActiveBg: '#EBF6FF',
        itemActiveBgDisabled: '#fff',
        itemBg: '#fff',
        borderRadius: 8,
      },
      Modal: {
        borderRadius: 16, // 设置你想要的圆角大小
        borderRadiusLG: 16,
      },
    },
  },
  yellow: {
    token: {
      colorPrimary: '#FFF026',
      colorBgLayout: '#FFF026',
    },
    components: {
      Input: {
        colorBgContainer: '#F2F4F7', // 背景色
        colorTextPlaceholder: '#9096A3', // Placeholder字体颜色
        colorText: '#1F2737', // 输入字体颜色
        borderRadius: 8,
        activeBorderColor: '#FFB200',
      },
      Select: {
        colorBgContainer: '#F2F4F7', // 背景色
        colorTextPlaceholder: '#9096A3', // Placeholder字体颜色
        colorText: '#1F2737', // 输入字体颜色
        activeBorderColor: '#FFF026', // 激活态边框色
        optionSelectedBg: '#EBF6FF',
        borderRadius: 8,
      },
      Button: {
        borderRadius: 8,
        /* 这里是你的组件 token */
        defaultColor: '#1F2737',
        defaultBorderColor: '#E5E7EB',
        defaultShadow: '#fff',
        defaultHoverBorderColor: '#C5C9D1',
        defaultHoverColor: '#1F2737',
        primaryColor: '#040B1A',
      },
      Table: {
        headerBg: '#F9FAFB', // 背景色
        headerColor: '#4B5363', // 表头文字颜色
        headerSplitColor: '#F9FAFB', // 表头分割线颜色
        headerBorderRadius: 8,
        borderRadius: 8,
        rowHoverBg: '#fafafa',
        rowSelectedBg: '#fff',
        rowSelectedHoverBg: '#fafafa',
      },
      Pagination: {
        itemActiveBg: '#EBF6FF',
        itemActiveBgDisabled: '#fff',
        itemBg: '#fff',
        borderRadius: 8,
      },
    },
  },
  sysop: {
    token: {
      colorPrimary: '#1890ff',
      colorBgLayout: '#f5f5f5',
      borderRadius: 4,
    },
    components: {
      Input: {
        // activeBg: '#fff',
        colorBgContainer: '#fff', // 背景色
        colorTextPlaceholder: '#9096A3', // Placeholder字体颜色
        colorText: 'rgba(0, 0, 0, 0.65)', // 输入字体颜色
        activeShadow: '0 0 0 2px rgba(24, 144, 255, 0.2)', // 不生效
        colorBorder: '#d9d9d9',
        // colorBorderBg: '#d9d9d9',
        activeBorderColor: '#40a9ff',
        borderRadius: 4,
      },
      InputNumber: {
        borderRadius: 4,
      },
      Select: {
        colorBgContainer: '#fff', // 背景色
        colorTextPlaceholder: '#9096A3', // Placeholder字体颜色
        colorText: 'rgba(0, 0, 0, 0.65)', // 输入字体颜色
        colorBorder: '#d9d9d9',
        activeBorderColor: '#40a9ff', // 激活态边框色
        optionActiveBg: '#e6f7ff',
        optionSelectedBg: '#e6f7ff',
        borderRadius: 4,
        controlHeightSM: 32,
      },
      Button: {
        borderRadius: 4,
        /* 这里是你的组件 token */
        defaultColor: 'rgba(0, 0, 0, 0.65)',
        defaultBorderColor: '#d9d9d9',
        defaultShadow: '#fff',
        defaultHoverBorderColor: '#C5C9D1',
        defaultHoverColor: '#1F2737',
        primaryColor: '#fff',
        colorLink: '#3385ff',
        colorLinkHover: '#40a9ff',
      },
      Table: {
        headerBg: '#dde6f0', // 背景色
        headerColor: '#355373', // 表头文字颜色
        headerSplitColor: '#dde6f0', // 表头分割线颜色
        headerBorderRadius: 4,
        borderRadius: 4,
        borderColor: '#e8e8e8',
        colorText: '#355373',
        rowHoverBg: '#e6f7ff',
        rowSelectedBg: '#fff',
        rowSelectedHoverBg: '#fafafa',
      },
      Pagination: {
        itemActiveBg: '#fff', // 选中项背景色
        itemActiveBgDisabled: '#fff',
        itemBg: '#fff',
        itemSizeSM: 32,
        borderRadius: 4,
        colorText: 'rgba(0, 0, 0, 0.65)',
        colorBgTextHover: '#fff',
        colorBgTextActive: '#fff',
        colorPrimaryHover: '#1890ff',
      },
      DatePicker: {
        borderRadius: 4,
      },
      Modal: {
        titleColor: 'rgba(0, 0, 0, 0.85)',
        borderRadiusLG: 4,
        fontWeightStrong: 500,
        marginXS: 0,
        // paddingContentHorizontalLG: 0,
        // paddingContentVerticalLG: 0,
      },
    },
  },
}

const Provider: FC<PropsWithChildren<Props>> = props => {
  const {children, themeType = 'blue', ...rest} = props
  const theme = themeConfig[themeType]
  return (
    <ConfigProvider variant={'filled'} theme={theme} {...rest} prefixCls={'astro-ui'} locale={locale}>
      {children}
    </ConfigProvider>
  )
}
export default Provider
